<template>
  <div class="xlt-workroom" v-if="mixinShowStudioInfo">
    <div class="room-l">
      <img :src="mixinStudio.logo | imgZip(200)" alt="" />
    </div>
    <div class="room-r">
      <div class="room-name-wrap">
        <p class="room-name">{{ mixinStudio.studio_name }}</p>
      </div>
      <div class="room-date" v-if="parsedWorkTime.length">
        <p
          class="date-span"
          v-for="(item, index) in parsedWorkTime"
          :key="index"
        >
          {{ item.title }}
          <i class="date-i" v-for="(t, i) in item.times" :key="i">{{ t }}</i>
        </p>
      </div>
      <div class="room-addr">
        {{ parsedAddress }}
      </div>
    </div>
  </div>
</template>

<script>
import expertXltMixin from 'mixins/xlt/expertXltMixin.js'

export default {
  mixins: [expertXltMixin],
  computed: {
    parsedAddress() {
      if (!this.mixinStudio) return ''
      // 省  市 区 详细地址
      const { province, city, district, address } = this.mixinStudio
      const arr = [province, city, district, address]
      return arr.filter(v => !!v).join('')
    },
    parsedWorkTime() {
      if (!this.mixinStudio) return []
      const { work_time = {} } = this.mixinStudio
      const keys = Object.keys(work_time)
      const res = []
      keys.forEach(key => {
        res.push({
          title: key,
          times: work_time[key]
        })
      })
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.xlt-workroom {
  width: 686px;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin: 30px auto;
  box-sizing: border-box;
  .room-r {
    flex: 1;
    .room-name-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      .room-name {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #21252d;
      }
    }
    .room-date {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9da3ac;
      margin-bottom: 4px;
      .date-i {
        font-style: normal;
        display: inline-block;
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .room-addr {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
    }
  }
  .room-l {
    img {
      width: 199px;
      height: 112px;
      background: #f3f4f5;
      border-radius: 10px;
      margin-right: 20px;
      object-fit: cover;
      flex-shrink: 0;
    }
  }
}
</style>
